module.exports = __webpack_public_path__ + "img/invoice_icon.78a40cf1.svg";